import React, { ReactElement, useEffect } from 'react';
import {
  DateRangePicker,
  LocalizationProvider,
  RangeInput,
} from '@material-ui/pickers';
import DateFnsUtils from '@material-ui/pickers/adapter/date-fns';
import { Box } from '@material-ui/core';
import enLocale from 'date-fns/locale/en-GB';
import defaultLocales from 'globals/locales/default';
import {
  FieldBox,
  RangePickerWrapperBox,
  StyledTextField,
} from './FsDateRangePicker.style-elements';

interface FsDateRangePickerProps {
  dateRange: RangeInput<Date>;
  onChange: (range: RangeInput<Date>) => void;
  onError?: (errorStatus: boolean) => void;
}

const FsDateRangePicker: React.FC<FsDateRangePickerProps> = ({
  dateRange,
  onChange,
  onError,
}) => {
  const [isOpen, setIsOpen] = React.useState<boolean>(false);
  const [isModified, setIsModified] = React.useState<boolean>(false);
  const [modifiedDateRange, setModifiedDateRange] = React.useState<
    RangeInput<Date>
  >(dateRange);

  const onChangeHandler = (dates: RangeInput<Date>): void => {
    setIsModified(true);
    setModifiedDateRange(dates);
  };

  const onErrorHandler = (
    reason: Array<string | null>
    // value: RangeInput<Date>
  ): void => {
    const errorStatus = reason.some((el) => el !== null);
    if (onError) onError(errorStatus);
  };

  useEffect(() => {
    if (!isOpen && isModified) {
      onChange(modifiedDateRange);
    }
  }, [isOpen, onChange, modifiedDateRange, isModified]);

  return (
    <RangePickerWrapperBox>
      <LocalizationProvider dateAdapter={DateFnsUtils} locale={enLocale}>
        <DateRangePicker
          startText={defaultLocales.from}
          endText={defaultLocales.to}
          value={dateRange}
          onChange={onChangeHandler}
          onClose={(): void => setIsOpen(false)}
          onOpen={(): void => {
            setIsOpen(true);
            // onErrorHandler(false);
          }}
          maxDate={new Date()}
          onError={onErrorHandler}
          renderInput={(startProps, endProps): ReactElement => (
            <>
              <FieldBox>
                <StyledTextField
                  {...startProps}
                  size="small"
                  helperText={false}
                  fullWidth
                />
              </FieldBox>

              <Box width={6} />

              <FieldBox isLast>
                <StyledTextField
                  {...endProps}
                  size="small"
                  helperText={false}
                  fullWidth
                />
              </FieldBox>
            </>
          )}
        />
      </LocalizationProvider>
    </RangePickerWrapperBox>
  );
};

export default FsDateRangePicker;
